export default __webpack_public_path__ + "static/media/22_1_0.7005b6e9.png";